import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64f31def"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "textDiv",
  class: "textDiv"
}
const _hoisted_2 = {
  id: "point__main_top",
  class: "point-main-top"
}
const _hoisted_3 = { class: "point-main-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "point_arrow_w",
  src: "/assets/icon/btn_back_w.png",
  srcset: "/assets/icon/btn_back_w@2x.png 2x,/assets/icon/btn_back_w@3x.png 3x"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "포인트", -1))
const _hoisted_6 = { class: "main-box" }
const _hoisted_7 = { class: "point_box space-between" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "point_title" }, " 보유포인트 ", -1))
const _hoisted_9 = { class: "point_value" }
const _hoisted_10 = { class: "strong" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" P ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "code_title" }, " 초대코드 · 할인코드 입력하기 ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/icon/btn_down.png",
  srcset: "/assets/icon/btn_down@2x.png 2x,/assets/icon/btn_down@3x.png 3x"
}, null, -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "invite_box" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 나의 초대링크 공유하기 ")
const _hoisted_18 = { id: "code" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "친구와 나에게 10,000P씩 적립!", -1))
const _hoisted_20 = {
  id: "point__main_info",
  class: "main-info"
}
const _hoisted_21 = { class: "space-between" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, " 총 적립 ", -1))
const _hoisted_23 = {
  key: 0,
  class: "info-value"
}
const _hoisted_24 = {
  key: 1,
  class: "info-value"
}
const _hoisted_25 = { class: "space-between" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, " 총 사용 ", -1))
const _hoisted_27 = {
  key: 0,
  class: "info-value"
}
const _hoisted_28 = {
  key: 1,
  class: "info-value"
}
const _hoisted_29 = { class: "space-between" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, " 총 소멸 ", -1))
const _hoisted_31 = {
  key: 0,
  class: "info-value"
}
const _hoisted_32 = {
  key: 1,
  class: "info-value"
}
const _hoisted_33 = { class: "space-between" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, " 소멸 예정 (3개월 내) ", -1))
const _hoisted_35 = {
  key: 0,
  class: "info-value"
}
const _hoisted_36 = {
  key: 1,
  class: "info-value"
}
const _hoisted_37 = {
  id: "point__main_tap",
  class: "main-tap"
}
const _hoisted_38 = {
  id: "point__save_box",
  class: "container"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "save_info_box" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "save_info" }, [
  /*#__PURE__*/_createTextVNode(" 적립된 Point가 없습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 나의 초대링크를 공유해보세요! ")
], -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "susy" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/image/susy.png",
    srcset: "/assets/image/susy@2x.png 2x,/assets/image/susy@3x.png 3x"
  })
], -1))
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "title" }
const _hoisted_45 = { class: "list_left" }
const _hoisted_46 = { class: "list-title" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 2 }
const _hoisted_50 = { class: "list-date" }
const _hoisted_51 = { class: "list_right" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "더보기", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "btn_down_b",
  src: "/assets/icon/btn_down_b.png",
  srcset: "/assets/icon/btn_down_b@2x.png 2x,/assets/icon/btn_down_b@3x.png 3x"
}, null, -1))
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = {
  id: "point__use_box",
  class: "container"
}
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { class: "use_info_box" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "save_info" }, [
  /*#__PURE__*/_createTextVNode(" 아직 사용하거나 소멸된 내역이 없습니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 클럽딜 참여에 포인트를 사용해보세요! ")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "susy" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/image/susy_o.png",
    srcset: "/assets/image/susy_o@2x.png 2x,/assets/image/susy_o@3x.png 3x"
  })
], -1))
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { class: "user_title title" }
const _hoisted_62 = { class: "list_left" }
const _hoisted_63 = { class: "list-title" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { key: 2 }
const _hoisted_67 = { class: "list-date" }
const _hoisted_68 = { class: "list_right" }
const _hoisted_69 = {
  key: 0,
  style: { color: '#4360EC' }
}
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "더보기", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "btn_down_b",
  src: "/assets/icon/btn_down_b.png",
  srcset: "/assets/icon/btn_down_b@2x.png 2x,/assets/icon/btn_down_b@3x.png 3x"
}, null, -1))
const _hoisted_72 = [
  _hoisted_70,
  _hoisted_71
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_collect_club_deals = _resolveComponent("collect-club-deals")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, null, 512),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: {name:'MyPage'},
                replace: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$clickTrackEvent({'clickArea':'헤더', 'clickContent':'뒤로가기', clickScreen: _ctx.clickScreen})))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _hoisted_5
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(typeof _ctx.point === 'undefined' ? '0' : _ctx.$filters.currency(_ctx.point)), 1),
                    _hoisted_11
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: "code_box space-between",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'카드영역', 'clickContent':'초대코드-할인코드 입력', clickScreen: _ctx.clickScreen});_ctx.createModal()})
              }, _hoisted_14),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  disabled: !_ctx.link,
                  class: "round_box",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'카드영역', 'clickContent':'나의 초대코드 복사', clickScreen: _ctx.clickScreen});_ctx.onShare()})
                }, [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.code), 1)
                ], 8, _hoisted_16),
                _hoisted_19
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              (Object.keys(_ctx.pointArr).length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 0 P "))
                : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.pointArr.saveTotalPoint)) + " P", 1)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              (Object.keys(_ctx.pointArr).length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, " 0 P "))
                : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.pointArr.useTotalPoint)) + " P", 1)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              (Object.keys(_ctx.pointArr).length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, " 0 P "))
                : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.pointArr.expireTotalPoint)) + " P", 1)
                  ]))
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              (Object.keys(_ctx.pointArr).length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, " 0 P "))
                : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$filters.currency(_ctx.pointArr.expectedExpireTotalPoint)) + " P", 1)
                  ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.activeTab === 'save' ? 'tab_selected' : 'tab_unselected']),
              onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'탭영역', 'clickContent':'적립내역', clickScreen: _ctx.clickScreen});_ctx.changeTab('save')})
            }, " 적립내역 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.activeTab === 'use' ? 'tab_selected' : 'tab_unselected']),
              onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'탭영역', 'clickContent':'사용 / 소멸내역', clickScreen: _ctx.clickScreen});_ctx.changeTab('use')})
            }, " 사용 / 소멸내역 ", 2)
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_38, [
            (_ctx.saveHistory.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _hoisted_42,
                    _createElementVNode("div", {
                      class: "save_code",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'적립내역탭', 'clickContent':'나의 초대코드 복사', clickScreen: _ctx.clickScreen});_ctx.onShare(_ctx.code)})
                    }, " 나의 초대링크 공유하기 " + _toDisplayString(_ctx.code), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, " 적립내역 " + _toDisplayString(_ctx.saveCount), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.saveHistory, (list, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "list-content"
                    }, [
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          (list.reasonType === 'invite')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, " 초대코드 "))
                            : (list.reasonType === 'promotion')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_48, " 할인코드 "))
                              : (_openBlock(), _createElementBlock("div", _hoisted_49, " 이벤트 / 기타 "))
                        ]),
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("span", null, _toDisplayString(list.createAt) + " ~ ", 1),
                          _createElementVNode("span", {
                            style: _normalizeStyle(_ctx.withIn90Days(list.expireAt) ? { color: '#FD6767' } : '')
                          }, _toDisplayString(list.expireAt), 5)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.$filters.currency(list.point)) + " P ", 1)
                    ]))
                  }), 128)),
                  _withDirectives(_createElementVNode("div", {
                    class: "load_btn",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'적립내역탭', 'clickContent':'더보기', clickScreen: _ctx.clickScreen});_ctx.addSaveHistory()})
                  }, _hoisted_54, 512), [
                    [_vShow, _ctx.saveToggle && _ctx.saveCount > 10]
                  ])
                ]))
          ], 512), [
            [_vShow, _ctx.activeTab === 'save']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_55, [
            (_ctx.useHistory.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                  _createElementVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _hoisted_59,
                    _createElementVNode("div", {
                      class: "save_code",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'사용/소멸내역 탭', 'clickContent':'클럽딜 보러가기', clickScreen: _ctx.clickScreen});_ctx.clubDealAllOpen=true;})
                    }, " 클럽딜 보러가기 ")
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, " 사용 / 소멸내역 " + _toDisplayString(_ctx.useCount), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useHistory, (list, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "list-content"
                    }, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          (list.type === 'cancel')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, " 사용 취소 "))
                            : (list.type === 'use')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_65, " 사용 "))
                              : (_openBlock(), _createElementBlock("div", _hoisted_66, " 소멸 "))
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _createElementVNode("span", null, _toDisplayString(list.createAt), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        (list.type === 'cancel')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_69, " +" + _toDisplayString(_ctx.$filters.currency(list.point)) + " P ", 1))
                          : (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              style: _normalizeStyle(list.type === 'expire' ? { color: '#B6BBC6' } : '')
                            }, _toDisplayString(_ctx.$filters.currency(list.point)) + " P ", 5))
                      ])
                    ]))
                  }), 128)),
                  _withDirectives(_createElementVNode("div", {
                    class: "load_btn",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.$clickTrackEvent({'clickArea':'사용/소멸내역 탭', 'clickContent':'더보기', clickScreen: _ctx.clickScreen});_ctx.addUseHistory()})
                  }, _hoisted_72, 512), [
                    [_vShow, _ctx.useToggle && _ctx.useCount > 10]
                  ])
                ]))
          ], 512), [
            [_vShow, _ctx.activeTab === 'use']
          ]),
          _createVNode(_component_collect_club_deals, {
            "model-value": _ctx.clubDealAllOpen,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = (value) => _ctx.clubDealAllOpen = value)
          }, null, 8, ["model-value"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}